import { render, staticRenderFns } from "./app-details.vue?vue&type=template&id=3b3c22b2&scoped=true&"
import script from "./app-details.vue?vue&type=script&lang=js&"
export * from "./app-details.vue?vue&type=script&lang=js&"
import style0 from "./app-details.vue?vue&type=style&index=0&id=3b3c22b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c22b2",
  null
  
)

export default component.exports